// pages/NotFound.tsx  
import React from 'react';
import { useNavigate } from 'react-router-dom'; 
import { PrimaryButton } from '../components/ButtonComponents';
import { navigateToDashboard } from '../utils/navigation';
import { useAuthStore } from '../store/authStore';

export const NotFound: React.FC = () => {
    const navigate = useNavigate();  
    const { user  } = useAuthStore(); 
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-bg text-text">
      <h1 className="text-9xl font-extrabold text-primary tracking-widest">404</h1>
      <div className="bg-secondary px-2 text-sm rounded rotate-12 absolute">
        Sayfa Bulunamadı
      </div>
      <PrimaryButton 
        className="mt-5 " 
        onClick={() => navigateToDashboard(user!,navigate)} 
      >
        Ana Sayfaya Dön
      </PrimaryButton>
    </div>
  );
};